exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".IndexPage-UseDiagram{text-align:center;margin-top:50px}.IndexPage-UseDiagram-Examples h2{margin:10px 0 5px}.IndexPage-UseDiagram-Examples>div{width:30%}.IndexPage-TabControl{max-width:500px;margin:0 auto;margin-bottom:30px}.IndexPage-Tabs{display:flex}.IndexPage-Tabs>a{margin-right:10px}@media (max-height:640px){.IndexPage-UseDiagram-Arrows svg{display:none!important}.IndexPage-UseDiagram-Arrows svg:nth-child(2){display:flex!important}.IndexPage-UseDiagram-Examples{flex-wrap:wrap}.IndexPage-UseDiagram-Examples>div{width:90%}}.IndexPage-Hero-Slides{flex:5;padding:20px 20px 20px 90px}.IndexPage-Hero-Slides img{width:90%}.IndexPage-Features{margin-top:80px;flex-wrap:wrap;font-weight:400}.IndexPage-ButtonBar,.IndexPage-Features{display:flex;flex-direction:row;justify-content:center}.IndexPage-ButtonBar{align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/index/index.css
// module id = ./src/pages/index/index.css
// module chunks = 2345137460201621000 17463659626562118000